const setGraphData_sell_acc_transfer = payload => {
  return {
    type: "setGraphData_sell_acc_transfer",
    payload
  };
};
export default setGraphData_sell_acc_transfer;
